import { render, staticRenderFns } from "./ExpressionOverlay.vue?vue&type=template&id=3e29d844&scoped=true&"
import script from "./ExpressionOverlay.vue?vue&type=script&lang=js&"
export * from "./ExpressionOverlay.vue?vue&type=script&lang=js&"
import style0 from "./ExpressionOverlay.vue?vue&type=style&index=0&id=3e29d844&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e29d844",
  null
  
)

export default component.exports